import { render, staticRenderFns } from "./QuotationItemsList.vue?vue&type=template&id=7b50be0b&"
import script from "./QuotationItemsList.vue?vue&type=script&lang=js&"
export * from "./QuotationItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports